import { useEffect, useState } from "react";
import apiClient from "../../../apiClient";
import { AssignResult, EntityType, InventoryItem, NewItemPayload } from "./types";
import useUnit from "../../../customHooks/useUnit";

export default function useItems() {
    const unit = useUnit();
    const [items, setItems] = useState<InventoryItem[]>([]);

    const getItems = async (forUnit: string | undefined = unit) => {
        const res = await apiClient.get(`/inventory/items`, { params: { unit: forUnit } });
        setItems(res.data);
    };

    useEffect(() => {
        getItems(unit);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [unit]);

    const addItem = async (payload: NewItemPayload) => {
        const res = await apiClient.post(`/inventory/items`, payload);
        return res.data as { itemId: string; quantity: number; serials: string[] };
    };

    const assignItem = async (itemId: string, fromUnit: string, entityType: EntityType, entityId: string, quantity: number) => {
        const res = await apiClient.post(`/inventory/assign`, { itemId, fromUnit, entityType, entityId, quantity });
        return res.data as AssignResult;
    };

    return { items, setItems, getItems, addItem, assignItem };
}
